import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'is',
    fullName: 'Icelandic',
    nativeName: 'Íslenska',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Eitthvað ótrúlegt er að koma",
    landing_subtitle: "ArgVoid er forrita- og leikjaþróunarstúdíó. Fylgstu með, nýir hlutir koma bráðum!",
    select_language: "Veldu Tungumál",
    search_placeholder: "Leita að tungumálum...",
    terms_title: "Þjónustuskilmálar",
    policy_title: "Persónuverndarstefna",
    cookies_title: "Vafrakökurstefna",
    terms_content: `
        <strong>1. Samþykki skilmála</strong><br>
        Með því að fá aðgang að ArgVoid eru þessir þjónustuskilmálar samþykktir. Ef ekki er fallist á þessa skilmála ætti ekki að nota þjónustuna.<br><br>

        <strong>2. Notkun palla</strong><br>
        ArgVoid og forrit þess eru veitt "eins og er" í upplýsinga- og skapandi tilgangi. Aðeins má nota þjónustuna í lögmætum tilgangi.<br><br>

        <strong>3. Bönnuð hegðun</strong><br>
        Það er stranglega bönnuð að nýta sér veikleika vefsvæðis, senda ruslpóst eða gera tilraunir með óviðkomandi aðgang að innviðunum.<br><br>

        <strong>4. Fyrirvari</strong><br>
        Hægt er að breyta pallinum og þjónustunni hvenær sem er án fyrirvara. Engin ábyrgð er veitt varðandi spennutíma eða framboð þjónustunnar.
    `,
    policy_content: `
        <strong>1. Upplýsingasafn</strong><br>
        Vettvangurinn krefst ekki auðkenningar notenda eða stofnunar reiknings eins og er. Engum persónuauðkenndum upplýsingum (svo sem nöfnum eða netföngum) er virkt safnað frá gestum.<br><br>

        <strong>2. Notkunargögn</strong><br>
        Hægt er að safna grunnum, nafnlausum greiningum til að skilja umferð á síðuna og bæta forritin. Þessi gögn eru ekki tengd við einstök notendaauðkenni.<br><br>

        <strong>3. Þjónusta þriðju aðila</strong><br>
        Þriðju aðila veitendur gætu verið notaðir fyrir hýsingu og greiningarþjónustu. Persónuverndarvenjur þessara viðkomandi veitenda stjórna nafnlausum gögnum sem unnið er með á innviðum þeirra.<br><br>

        <strong>4. Gagnaöryggi</strong><br>
        Sanngjarnar öryggisráðstafanir eru gerðar til að vernda pallinn. Hins vegar er engin aðferð við sendingu yfir internetið algjörlega örugg.<br><br>
    `,
    cookies_content: `
        <strong>1. Hvað eru vafrakökur og staðbundin geymsla?</strong><br>
        Vafrakökur og staðbundin geymsla vafra eru litlar gagnaskrár sem eru geymdar á tækinu til að muna stillingarstillingar yfir heimsóknir.<br><br>

        <strong>2. Notkunartilgangur</strong><br>
        Browser LocalStorage er notað stranglega til að vista stillingar, svo sem: <br>
        - Tungumálastillingar<br>
        - Uppsetning notendaviðmóts (t.d. skipulag eða þemastillingar) <br>
        - Tímabundið skyndiminni forrita<br><br>

        <strong>3. Engin mælingar</strong><br>
        Vafrakökur og staðbundin geymsla eru ekki notuð í auglýsingaskyni eða til rakningar frá þriðja aðila. Öll geymd gögn eru eingöngu fyrir kjarnavirkni pallsins.<br><br>

        <strong>4. Control</strong><br>
        Hægt er að hreinsa vafragögn hvenær sem er í gegnum stillingar vafrans, sem mun endurstilla allar staðbundnar stillingar.
    `,
    cookie_consent_text: "Við notum grunnkökur til að tryggja að vefsíðan virki rétt, svo sem að halda lotunni þinni virkri, vista tungumálavalið þitt og aðrar sérsniðnar stillingar.",
    read_policy: "Lestu Cookie Policy",
    support_title: "Hafðu samband við þjónustudeild",
    support_subject_label: "Efni",
    support_message_label: "Skilaboð",
    support_submit_button: "Sendu skilaboð",
    support_hint: "Athugið: Þetta mun opna sjálfgefið tölvupóstforrit til að senda skilaboðin.",
    support_success_msg: "Opnar tölvupóstforritið þitt...",
    support_error_msg: "Mistókst að senda skilaboð. Vinsamlegast reyndu aftur síðar.",
    explorer_title: "Landkönnuður",
    history_title: "Saga",
    animation_title: "Hreyfimynd",
    config_title: "Stillingar",
    tool_mouse: "Veldu (Ctrl+M)",
    tool_brush: "Bursta (Ctrl+B)",
    tool_brush_mode: "Skiptastillingu (fast/tært)",
    tool_eraser: "Strokleður (Ctrl+E)",
    tool_brush_size: "Stilltu stærð bursta",
    tool_bucket: "Fylla (Ctrl+F)",
    tool_eyedropper: "Augndropa",
    tool_grid: "Tafla (Ctrl+Shift+B)",
    tool_rotate: "Snúa (Ctrl+Shift+R)",
    tool_flip_h: "Snúðu H (Ctrl+Shift+H)",
    tool_flip_v: "Snúa V (Ctrl+Shift+V)",
    tool_transpose: "Flytja (Ctrl+Shift+T)",
    label_width: "Breidd",
    label_height: "Hæð",
    label_frames: "Fjöldi ramma",
    label_animation: "Hreyfimyndastíll",
    label_background_color: "Bakgrunnslitur",
    label_interval: "Tímabil",
    tool_anim_config: "Hreyfimyndastillingar",
    label_new_width: "Ný breidd",
    label_new_height: "Ný hæð",
    label_apply: "Sækja um",
    label_colors: "Litir",
    label_size: "Stærð",
    label_tolerance: "Umburðarlyndi",
    val_horizontal: "Lárétt",
    val_vertical: "Lóðrétt",
    val_sequence: "Röð",
    val_bounce: "Hopp",
    val_random: "Handahófi",
    val_solid: "Solid",
    val_clear: "Hreinsa",
    action_add_sheet: "Nýtt blað",
    action_import: "Innflutningur",
    action_export: "Útflutningur",
    action_sort_projects: "Raða",
    sort_date_old: "Elst fyrst",
    sort_date_new: "Nýjasta fyrst",
    sort_name_az: "Nafn (A-Ö)",
    sort_name_za: "Nafn (Z-A)",
    action_new_sprite: "Nýr Sprite",
    action_new_project: "Nýtt verkefni",
    modal_save_all_title: "Vista allar breytingar",
    modal_save_all_desc: "Veldu þær eignir sem á að vista:",
    modal_save_selected: "Vista valið",
    action_saved: "Vistað",
    modal_create_sprite_title: "Búðu til nýjan Sprite",
    modal_create_project_title: "Búa til nýtt verkefni",
    modal_add_sheet_title: "Bæta við nýju blaði",
    modal_rename_sheet_title: "Endurnefna blað",
    modal_rename_sprite_title: "Endurnefna Sprite",
    modal_delete_sprite_title: "Eyða Sprite",
    modal_delete_project_title: "Eyða verkefni",
    modal_delete_sheet_title: "Eyða blaði",
    placeholder_sprite_name: "Nafn",
    placeholder_project_name: "Nafn",
    placeholder_sheet_name: "Nafn",
    placeholder_new_name: "Nýtt nafn",
    action_create: "Búa til",
    action_add: "Bæta við",
    action_rename: "Endurnefna",
    action_duplicate: "Afrit",
    action_delete: "Eyða",
    action_cancel: "Hætta við",
    confirm_delete_sprite: "Ertu viss um að þú viljir eyða þessum sprite?",
    confirm_delete_project: "Ertu viss um að þú viljir eyða þessu verkefni? Allir sprites verða fjarlægðir.",
    confirm_delete_sheet: "Ertu viss um að þú viljir eyða þessu blaði?",
    err_select_sprite: "Vinsamlegast veldu sprite fyrst.",
    err_select_project: "Vinsamlegast veldu verkefni fyrst.",
    err_name_empty: "Nafn má ekki vera autt.",
    err_sprite_exists: "Sprite með því nafni er þegar til.",
    err_project_exists: "Verkefni með því nafni er þegar til.",
    err_no_content: "Ekkert efni til að vista.",
    err_no_changes: "Engar breytingar til að vista.",
    err_delete_last_sheet: "Ekki er hægt að eyða síðasta blaði.",
    err_extract_frames: "Ekki tókst að draga út neina ramma.",
    err_indexeddb: "Ekki tókst að vista á staðnum. Vafrinn þinn styður kannski ekki IndexedDB.",
    msg_upload_success: "Upphleðsla tókst: {0}",
    msg_upload_failed: "Upphleðsla mistókst: {0}",
    msg_save_success: "Vistun tókst.",
    msg_saving: "Vistar...",
    msg_multi_save_result: "{0} vistaðar eignir. {1} bilanir.",
    menu_title: "Matseðill",
    menu_save: "Vista",
    menu_save_all: "Vista allt",
    menu_support: "Hafðu samband við þjónustudeild",
    label_local_storage: "Staðbundin geymsla",
    label_sign_in: "Skráðu þig inn",
    modal_export_title: "Flytja út Sprite",
    label_filename: "Skráarnafn",
    label_format: "Snið",
    action_export_confirm: "Útflutningur",
};

export default translations;
